import React from 'react';
import ReactDOM from 'react-dom';
import { DeleteButton } from 'shared/buttons';
import ConfirmDialogue from 'shared/modals/ConfirmDialogue';

let confirmContainer = null;
let closeConfirmDialogCallback = null;

const StandaloneConfirmDialog = ({ isOpen, onClose, title, message, confirmText, cancelText, ...props }) => {
  const [currentPath] = React.useState(window.location.pathname);
  
  React.useEffect(() => {
    // Set up global access to close the dialog
    window.closeConfirmDialog = () => onClose(false);
    closeConfirmDialogCallback = () => onClose(false);
    
    // Function to check for navigation changes
    const handleNavigation = () => {
      if (window.location.pathname !== currentPath) {
        onClose(false);
      }
    };
    
    // Listen for navigation events
    window.addEventListener('popstate', handleNavigation);
    
    // Set up a periodic check for URL changes (for programmatic navigation)
    const intervalId = setInterval(() => {
      if (window.location.pathname !== currentPath) {
        onClose(false);
      }
    }, 100);
    
    return () => {
      // Clean up
      window.removeEventListener('popstate', handleNavigation);
      clearInterval(intervalId);
      delete window.closeConfirmDialog;
      closeConfirmDialogCallback = null;
    };
  }, [currentPath, onClose]);
  
  return (
    <ConfirmDialogue
      isOpen={isOpen}
      handleClose={onClose}
      headerText={title}
      text={message}
      confirmText={confirmText}
      cancelText={cancelText}
      ConfirmComponent={DeleteButton}
      {...props}
    />
  );
};

// Function to create and show the confirmation dialog
export const confirm = ({ title = 'Confirm', message = 'Are you sure?', confirmText = 'Yes', cancelText = 'No', ...props }) => {
  return new Promise((resolve) => {
    if (!confirmContainer) {
      confirmContainer = document.createElement('div');
      confirmContainer.className = 'confirm-dialog-container';
      confirmContainer.style.position = 'relative';
      confirmContainer.style.zIndex = 9999;
      document.body.appendChild(confirmContainer);
    }
    
    const handleClose = (result) => {
      ReactDOM.unmountComponentAtNode(confirmContainer);
      resolve(result);
    };
    
    ReactDOM.render(
      <StandaloneConfirmDialog
        isOpen={true}
        onClose={handleClose}
        title={title}
        message={message}
        confirmText={confirmText}
        cancelText={cancelText}
        {...props}
      />,
      confirmContainer
    );
  });
};